// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
import * as Faker from "faker";

function getLocale(param) {
  return Faker.locale;
}

function string_from_locale(param) {
  switch (param) {
    case
    /* Az */
    0:
      return "az";

    case
    /* Cz */
    1:
      return "cz";

    case
    /* De */
    2:
      return "de";

    case
    /* De_AT */
    3:
      return "de_AT";

    case
    /* De_CH */
    4:
      return "de_CH";

    case
    /* En */
    5:
      return "en";

    case
    /* En_AU */
    6:
      return "en_AU";

    case
    /* En_BORK */
    7:
      return "en_BORK";

    case
    /* En_CA */
    8:
      return "en_CA";

    case
    /* En_GB */
    9:
      return "en_GB";

    case
    /* En_IE */
    10:
      return "en_IE";

    case
    /* En_IND */
    11:
      return "en_IND";

    case
    /* En_US */
    12:
      return "en_US";

    case
    /* En_au_ocker */
    13:
      return "en_au_ocker";

    case
    /* Es */
    14:
      return "es";

    case
    /* Es_MX */
    15:
      return "es_MX";

    case
    /* Fa */
    16:
      return "fa";

    case
    /* Fr */
    17:
      return "fr";

    case
    /* Fr_CA */
    18:
      return "fr_CA";

    case
    /* Ge */
    19:
      return "ge";

    case
    /* Id_ID */
    20:
      return "id_ID";

    case
    /* It */
    21:
      return "it";

    case
    /* Ja */
    22:
      return "ja";

    case
    /* Ko */
    23:
      return "ko";

    case
    /* Nb_NO */
    24:
      return "nb_NO";

    case
    /* Nep */
    25:
      return "nep";

    case
    /* Nl */
    26:
      return "nl";

    case
    /* Pl */
    27:
      return "pl";

    case
    /* Pt_BR */
    28:
      return "pt_BR";

    case
    /* Ru */
    29:
      return "ru";

    case
    /* Sk */
    30:
      return "sk";

    case
    /* Sv */
    31:
      return "sv";

    case
    /* Tr */
    32:
      return "tr";

    case
    /* Uk */
    33:
      return "uk";

    case
    /* Vi */
    34:
      return "vi";

    case
    /* Zh_CN */
    35:
      return "zh_CN";

    case
    /* Zh_TW */
    36:
      return "zh_TW";
  }
}

function setLocale(locale) {
  var locale_string = string_from_locale(locale);
  Faker.locale = locale_string;
}

export { getLocale, setLocale };
/* faker Not a pure module */